import React, { useState } from 'react';
import './UserComponent.css';
import man from '../../Assets/Man.png';
import { message } from 'antd';

function UserComponent({ isEditing, userData, setUserData, profileImage, setProfileImage }) {
  const [imageError, setImageError] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      message.error('Please select a valid image (JPEG, PNG, GIF, or WebP)');
      return;
    }
    
    // Validate file size
    const maxSize = 2 * 1024 * 1024; // 2MB
    if (file.size > maxSize) {
      message.error('Image size should be less than 2MB');
      return;
    }

    // Create preview
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event.target.result) {
        setProfileImage(file); // Store the File object
        setUserData(prev => ({ 
          ...prev, 
          profileImagePreview: event.target.result 
        }));
        setImageError(false);
      }
    };
    reader.onerror = () => {
      message.error('Error reading image file');
      setImageError(true);
    };
    reader.readAsDataURL(file);
  };

  const displayImage = () => {
    if (imageError) return man;
    if (userData.profileImagePreview) return userData.profileImagePreview;
    if (typeof profileImage === 'string') {
      return profileImage.startsWith('data:image') 
        ? profileImage 
        : `data:image/jpeg;base64,${profileImage}`;
    }
    return man;
  };

  return (
    <div className="user-component-container">
      <div className="profile-image-container">
        <img 
          src={displayImage()} 
          alt="profile" 
          className="user-img" 
          onError={(e) => {
            e.target.src = man;
            setImageError(true);
          }}
        />
      </div>
      
      {isEditing && (
        <>
          <input 
            type="file" 
            accept="image/*" 
            onChange={handleImageChange}
            style={{ display: 'none' }}
            id="profileImageUpload"
          />
          <label htmlFor="profileImageUpload" className="upload-image">
            {profileImage ? 'Change Photo' : 'Upload Photo'}
          </label>
          {profileImage && (
            <span 
              className="remove-image"
              onClick={() => {
                setProfileImage(null);
                setUserData(prev => ({...prev, profileImagePreview: null, profileImage: null,}));
              }}
            >
              Remove Photo
            </span>
          )}
        </>
      )}
      
      {isEditing ? (
        <>
          <div className="input-group">
            <label className="input-label" htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              className="user-input"
              value={userData.name || ''}
              onChange={(e) => setUserData(prev => ({
                ...prev,
                name: e.target.value
              }))}
            />
          </div>
          <div className="input-group">
            <label className="input-label" htmlFor="instructorTitle">Title</label>
            <input
              type="text"
              id="instructorTitle"
              className="user-input"
              value={userData.instructorTitle || ''}
              onChange={(e) => setUserData(prev => ({
                ...prev,
                instructorTitle: e.target.value
              }))}
            />
          </div>
        </>
      ) : (
        <>
          <span className="user-name">{userData.name || ''}</span>
          <span className="user-role">{userData.role || ''}</span>
        </>
      )}
      
      <div className="user-email">
        <span className="user-email-text">Email</span>
        <span className="user-email-text-bg">{userData.username || ''}</span>
      </div>
    </div>
  );
}

export default UserComponent;